import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { redirectToBack } from 'srcReact/helpers/history'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import WorkplaceTile from 'srcReact/components/common2/WokplaceTile'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

const MobileHeader = ({ activeItem, setActiveItem, selectedWorkplace, handleSelectedWorkplace }) => {
  const { t } = useTranslation()

  const {
    common: { isNative },
    workplaceSettings: { workplace_list }
  } = useSelector((state) => state)

  const handleBackButton = () => {
    if (activeItem === t('workplaceSettings.title')) {
      redirectToBack(isNative)
    }
    setActiveItem(t('workplaceSettings.title'))
  }

  const getWorkplaceLabel = (workplace) => {
    return (
      <WorkplaceTile
        workplaceId={workplace.id}
        workplaceName={workplace.name}
        color={workplace.color}
        initials={workplace.initials}
        size='tiny'
        isNative={isNative}
      />
    )
  }

  return (
    <div className={styles.mobileHeaderWrapper}>
      <div className={styles.mobileHeader}>
        <BackNavigation className={styles.back} customHandleBack={handleBackButton} />
        <Dropdown1
          className={styles.dropdownClassName}
          size='full'
          value={{ value: selectedWorkplace.id, label: getWorkplaceLabel(selectedWorkplace) }}
          options={workplace_list?.map((w) => ({ value: w.id, label: getWorkplaceLabel(w), workplace: w })) || []}
          onChange={({ value }) => handleSelectedWorkplace(value)}
          isSearchable={false}
        />
      </div>
    </div>
  )
}

export default MobileHeader
